import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import AddBoxOutlined from '@mui/icons-material/AddBoxOutlined';
import AdminPanelSettingsOutlined from '@mui/icons-material/AdminPanelSettingsOutlined';
import AnalyticsOutlined from '@mui/icons-material/AnalyticsOutlined';
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';
import ArticleOutlined from '@mui/icons-material/ArticleOutlined';
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';
import BrightnessHighOutlined from '@mui/icons-material/BrightnessHighOutlined';
import BusinessCenterOutlined from '@mui/icons-material/BusinessCenterOutlined';
import ChatOutlined from '@mui/icons-material/ChatOutlined';
import CardMembershipOutlined from '@mui/icons-material/CardMembershipOutlined';
import CategoryOutlined from '@mui/icons-material/CategoryOutlined';
import CssOutlined from '@mui/icons-material/CssOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import DesignServicesOutlined from '@mui/icons-material/DesignServicesOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import Google from '@mui/icons-material/Google';
import EditOutlined from '@mui/icons-material/EditOutlined';
import EmojiEventsOutlined from '@mui/icons-material/EmojiEventsOutlined';
import GavelOutlined from '@mui/icons-material/GavelOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import ImageOutlined from '@mui/icons-material/ImageOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import LocalCafeOutlined from '@mui/icons-material/LocalCafeOutlined';
import MapOutlined from '@mui/icons-material/MapOutlined';
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import PaletteOutlined from '@mui/icons-material/PaletteOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import PodcastsOutlined from '@mui/icons-material/PodcastsOutlined';
import PublicOutlined from '@mui/icons-material/PublicOutlined';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';
import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined';
import SupervisedUserCircleOutlined from '@mui/icons-material/SupervisedUserCircleOutlined';
import TravelExploreOutlined from '@mui/icons-material/TravelExploreOutlined';
import VideoLibraryOutlined from '@mui/icons-material/VideoLibraryOutlined';
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';

/**
 * Maps {@link NavStore} `icon` string keys to MUI icons (design names from Figma → Material symbols).
 */
export const NAV_ICON_MAP: Record<string, React.ComponentType<SvgIconProps>> = {
  plusSquare: AddBoxOutlined,
  microcast: PodcastsOutlined,
  cog: SettingsOutlined,
  openai: AutoAwesomeOutlined,
  map: MapOutlined,
  course: SchoolOutlined,
  program: AccountTreeOutlined,
  document: DescriptionOutlined,
  archive: Inventory2Outlined,
  resources: WidgetsOutlined,
  playCircle: PlayCircleOutline,
  image: ImageOutlined,
  pdf: PictureAsPdfOutlined,
  maskGroup: SupervisedUserCircleOutlined,
  fileStar: EmojiEventsOutlined,
  portal: PublicOutlined,
  infoCircle: InfoOutlined,
  palette: PaletteOutlined,
  designServices: DesignServicesOutlined,
  smartToy: SmartToyOutlined,
  css: CssOutlined,
  cardMembership: CardMembershipOutlined,
  people: PeopleOutlined,
  edit: EditOutlined,
  cup: LocalCafeOutlined,
  brightnessUp: BrightnessHighOutlined,
  user: PersonOutlined,
  reporting: AnalyticsOutlined,
  compliance: GavelOutlined,
  dashboard: DashboardOutlined,
  briefcase: BusinessCenterOutlined,
  users: GroupsOutlined,
  system: AdminPanelSettingsOutlined,
  video: VideoLibraryOutlined,
  chat: ChatOutlined,
  google: Google,
  storefront: StorefrontOutlined,
  category: CategoryOutlined,
  article: ArticleOutlined,
  menuBook: MenuBookOutlined,
  travelExplore: TravelExploreOutlined,
};

export function NavSidebarIcon({
  name,
  active,
}: {
  name: string | undefined;
  active: boolean;
}) {
  if (!name) {
    return null;
  }
  const Cmp = NAV_ICON_MAP[name];
  if (!Cmp) {
    return null;
  }
  return (
    <Cmp
      fontSize="small"
      color={active ? 'primary' : 'action'}
    />
  );
}
